import React from 'react'
import { ReactComponent as CloseIcon } from '../../../assets/images/XgreyIcon.svg'
import Dropdown from '../../clients/components/DropDown'
import styles from './fi.module.css'

interface Option {
  key: string
  value: string
}

interface FilterBarProps {
  filterType: 'Country' | 'Financial Institution'
  searchValue: string
  setFilterType: (type: 'Country' | 'Financial Institution') => void
  setSearchValue: (value: string) => void
  filterOptions: Option[]
}

const FilterBar: React.FC<FilterBarProps> = ({
  filterType,
  searchValue,
  setFilterType,
  setSearchValue,
  filterOptions,
}) => {
  return (
    <div className={styles.filterBarContainer}>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder={`Search by ${filterType || '...'}`}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className={styles.searchInput}
          style={{
            maxWidth: searchValue ? '90%' : '100%',
          }}
        />
        {searchValue && (
          <button
            onClick={() => setSearchValue('')}
            className={styles.clearButton}
          >
            <CloseIcon width={30} height={30} />
          </button>
        )}
      </div>
      <Dropdown
        options={filterOptions}
        initialState={filterType}
        handleSelect={(val: string) => {
          setFilterType(val as 'Country' | 'Financial Institution')
          setSearchValue('')
        }}
      />
    </div>
  )
}

export default FilterBar
